// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2YIjY","dragIcon":"SortableItem_dragIcon__1006q","disabled":"SortableItem_disabled__2Utdb"};